/**
 * Created by fworld on 2019/7/24.
 */
export default {
    title: {
        text: '设备保养分布',
        x: 'center',
        show: "false",
        top: '0',
        left: '52%',
        textStyle: {
            color: '#c2c2c2'
        }
    },
    grid: {
        left: '8%',
        top: '0',
        containLabel: true
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    // legend: {
    //     type: 'scroll',
    //     orient: 'vertical',
    //     right: 0,
    //     data: ['牛奶系统清洗', '除垢', '冲煮系统清洗', '冲泡器清洁', '磨豆校验', '搅拌器清洗', '粉料校验'],
    //     textStyle: {
    //         color: '#c2c2c2',
    //         fontSize: '12px',
    //     },
    //     pageStyle: {
    //         color: '#333',
    //         fontSize: '12px',
    //     }
    // },
    series: [
        {
            name: '异常类型',
            type: 'pie',
            radius: ['24%', '48%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: false,
            label: {
                normal: {
                    show: true,
                    fontSize: '12'
                },
                emphasis: {
                    show: true,
                    fontSize: '12'
                }
            },
            labelLine: {
                normal: {
                    show: true
                }
            },
            data: [
                {value: 335, name: '牛奶系统清洗'},
                {value: 310, name: '除垢'},
                {value: 234, name: '冲煮系统清洗'},
                {value: 135, name: '冲泡器清洁'},
                {value: 1548, name: '磨豆校验'},
                {value: 1548, name: '搅拌器清洗'},
                {value: 1548, name: '粉料校验'}
            ],
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
}
